export default __webpack_public_path__ + "static/media/starting_line_six_boys.4426be25.jpg";